<form [formGroup]="searchForm" (ngSubmit)="onSubmit()" class="pb-2">
    <div class="input-group">
        <!-- SEARCH INPUT -->
        <input type="text" class="form-control" aria-label="Search Articles"
        placeholder="Search Articles" formControlName="searchInput" [ngClass]="{ 'is-invalid': searchForm.invalid && searchForm.touched && searchForm.dirty }"
        required minlength="4" maxlength="50" id="searchInput">

        <!-- SEARCH BUTTON -->
        <button id="btnSearch" class="btn btn-outline-primary" type="submit" name="Search Articles"
            aria-label="Search Articles">
            <fa-icon [icon]="faSearch"></fa-icon>
        </button>
    </div>

    <div [style.opacity]="(searchForm.invalid && (searchForm.dirty || searchForm.touched))?1:0" class="warning danger">     
            Search text must 4-50 characters.      
    </div>
</form> 